<svelte:body on:item={put_item} />
<script>
    import _ from 'lodash';
    import {validate_int} from '../../../validators.js';
    import {parameter, network} from '../../../stores.js';
    import {createEventDispatcher} from 'svelte';
    import {precision} from '../../../config.js';
    import RalColor from "../../parts/RalColor.svelte";

    const dispatch = createEventDispatcher();
    const fixprecision = (value) => Math.ceil(value * precision) / precision;

    export let calc;
    export let options;

    const polotno = options.polotno || {
        'Наносетка': 'Наносетка',
        'Сетка москитная, Максимальный обзор': 'Максимальный обзор',
        'Сетка москитная, PPE': 'PPE',
        'Сетка москитная, АнтиМОШКА':'АнтиМОШКА',
        'Сетка москитная, Антикошка серебро': 'Антикошка серебро',
        'Сетка москитная, алюминиевая':'Алюминиевая',
        'Сетка москитная, антикошка белое':'Антикошка белое',
        'Сетка москитная, антикошка черное': 'Антикошка черное',
        'Сетка москитная, гипоаллергенная':'Гипоаллергенная',
        'Сетка москитная, стандарт': 'Стандарт',
        'Оконный фильтр Оберег':'Оконный фильтр Оберег'
    }

    export let put_item = async (e) => {
        let item = e.detail;

        if (item) {
            let title = item.title.split(' ');

            width.set(title[4].split('x')[0]);
            height.set(title[4].split('x')[1]);
            ind2.set(title[5]);
            ind3 = Object.keys(polotno).find((el) => item.title.toLowerCase().includes(el.toLowerCase()));

            count.set(+item.quantity);
            comment.set(item.comment);

            fetchData = await fetch($ind2);
            change();
        }
    };

    const color = options.color || {
        'Белый':'Белый',
        'Анодированный(коньяк)':'Анодированный(коньяк)',
    }


    const fetch = async (color = 'Белый') => {
        let result = await network.fetch_data('Детская', '', color);
        let options = await network.fetch_ind('Детская');

        return {
            name: _.groupBy(result, 'name'),
            ind1: _.groupBy(result, 'ind1'),
            ind2: _.groupBy(result, 'ind2'),
            ind3: _.groupBy(result, 'ind3'),
            edIzmer: _.groupBy(result, 'edIzmer'),
            options,
            result,
        }
    }

    let
        width = parameter('width', '800'),
        height = parameter('height', '1500'),

        ind2 = parameter('color', Object.values(color).shift()), // цвет
        ind3 = 'Сетка москитная, стандарт', // полотно

        // другое
        comment = parameter('comment', ''),
        count = parameter('count', 1)
    ;

    let fetchData = fetch($ind2);
    let
        montage_item,
        montage_price = 1;

    const changeInd2 = () => {fetchData = fetch($ind2)};

    // расчёт стоимости
    const change = _.debounce(async () => {
        let data = await fetchData;

        let
            quantity = +$count,

            w = +$width,
            h = +$height
        ;

        let dimensions = [w, h].join('×');
        let result = {
            type: 'защита-о2',
            name: 'Защита нового поколения О2',
            subname: [w + 'x' + h, ' ', $ind2, ' ', ind3].join(''),
            title: [
                'Защита нового поколения О2', ' ', w + 'x' + h, ' ',
                $ind2, ' ', ind3

            ].join(''),
            params: {
                ind1: dimensions,
                ind2: $ind2,
                ind3: ind3,
                ind4: $width,
                ind5: $height,
            },
            price: {rozn: 0, opt: 0, sebest: 0,},
            quantity,
            materials: {},
            comment: $comment,
            vStrukture: 16,
        };

        _.forEach(data.result, function(item) {
            let name = item.name.toLowerCase();

            let price = {rozn: 0, opt: 0, sebest: 0}
            let kolvo = 0;

            if (name.includes('профиль вставной детский')) {
                kolvo = (((w + 20) * 2 + (h + 20) * 2) / 1000).toFixed(3);
            }

            if (name.includes('профиль поперечный детский')) {
                if ((h >= 900) && (h <= 1800)) {
                    kolvo = ((w - 34) / 1000).toFixed(3);
                } else if (h >= 1800) {
                    kolvo = ((w - 34) / 1000 * 2).toFixed(3);
                }
            }

            if (name.includes('шнур фиксирующий') && ind3 !== 'Нет') {
                if (h <= 900) {
                    kolvo = (((w + 20) * 2 + (h + 20) * 2) / 1000).toFixed(3);
                } else if ((h > 900) && (h <= 1800)) {
                    kolvo = (((w + 20) * 4 + (h + 20) * 2) / 1000).toFixed(3);
                } else {
                    kolvo = (((w + 20) * 6 + (h + 20) * 2) / 1000).toFixed(3);
                }
            }

            if (name.includes('дистанционная проставка')) {
                if (h <= 900) {
                    kolvo = (Math.round(((h - 25) - Math.round(((h - 25)) / 148) * 58) / 90) * 2).toFixed(3);
                } else if ((h > 900) && (h <= 1800)) {
                    kolvo = (Math.round(((h - 25) / 2 - Math.round(((h - 25) / 2) / 148) * 58) / 90) * 4).toFixed(3);
                } else {
                    kolvo = (Math.round(((h - 25) / 3 - Math.round(((h - 25) / 3) / 148) * 58) / 90) * 4).toFixed(3);
                }
            }

            if (name.includes('угол соединительный мс вставная')) {
                kolvo = (4).toFixed(3);
            }

            if (name.includes('шнур монолинь')) {
                kolvo = (0.25 * 2).toFixed(3);
            }

            if (
                name.includes('комплект креплений, 58мм') ||
                name.includes('наклейка') ||
                name.includes('инструкция') ||
                name.includes('работа')
            ) {
                kolvo = (1).toFixed(3)
            }

            if (name.includes('монтаж')) {
                montage_item = item;
            }

            if (name.includes('ламели')) {
                if (h <= 900) {
                    kolvo = (Math.ceil(((h - 25)) / 148) * (w - 15) / 1000).toFixed(3);
                } else if ((h > 900) && (h <= 1800)) {
                    kolvo = (Math.ceil(((h - 25) / 2) / 148) * 2 * (w - 15) / 1000).toFixed(3);
                } else {
                    kolvo = (Math.ceil(((h - 25) / 3) / 148) * 3 * (w - 15) / 1000).toFixed(3);
                }
            }

            if (name.includes('саморез')) {
                if ((h > 900) && (h <= 1800)) {
                    kolvo = (2).toFixed(3);
                } else {
                    kolvo = (4).toFixed(3);
                }
            }

            if ((name.includes('сетка москитная') || name === 'наносетка' || name.includes('фильтр')) && name.indexOf(ind3.toLowerCase()) >= 0) {
                kolvo = (w * h / 1000000).toFixed(3);
            }


            if (kolvo) {
                price['rozn'] = fixprecision(kolvo * (1 + item.procentSpisania / 100) * item.price);
                price['opt'] = fixprecision(kolvo * (1 + item.procentSpisania / 100) * item.opt_price);
                price['sebest'] = fixprecision(kolvo * (1 + item.procentSpisania / 100) * item.sebestomost);

                result.materials[item.name] = {
                    order: +item.poryadok,
                    id: item.idTovar,
                    spis: item.procentSpisania,
                    type: item.edIzmer,
                    oprice: {
                        rozn: (+item.price).toFixed(2),
                        opt: (+item.opt_price).toFixed(2),
                        sebest: (+item.sebestomost).toFixed(2),
                    },
                    price,
                    quantity,
                    count: (+kolvo).toFixed(3)
                };
            }
        });

        result.price.rozn = _.sumBy(_.values(_.mapValues(result.materials, (o) => o.price)), 'rozn').toFixed(2);
        result.price.opt = _.sumBy(_.values(_.mapValues(result.materials, (o) => o.price)), 'opt').toFixed(2);
        result.price.sebest = _.sumBy(_.values(_.mapValues(result.materials, (o) => o.price)), 'sebest').toFixed(2);


        if (montage_item) {
            let mprice = Math.round((result.price.rozn / quantity) / 100 * montage_item.procentSpisania / 100) * 100;
            montage_price = +(montage_item.opt_price > mprice ? montage_item.opt_price * quantity : mprice * quantity).toFixed(2);
            dispatch('mounting', {item: montage_item, price: montage_price});
        }

        dispatch('item', result);
    }, 250);

    change();
</script>

{#await fetchData}
    <div class="card-body">
        <div class="text-center">
            <p>Загрузка..</p>
        </div>
    </div>
{:then data}
    <!--<pre>{JSON.stringify(data.edIzmer["кв.м"], null, 4)}</pre>-->
    <div class="card-body" on:keyup={change} on:paste={change} on:change={change}>
        <div class="row">



            {#if APP_TYPE === 'plisse-ltd'}

                <div class="col-12  text-center d-flex order-last  order-sm-first justify-content-around">
                    <img style="max-height: 250px"
                         class="img-fluid p-3"
                         src="{ $ind2 === 'Белый(9016RAL)' ? 'https://iem.plisse.ltd/tradeMasterImages/plisseltd/o2w.jpg' : $ind2 === 'Анодированный(коньяк)' || $ind2 === 'Коричневый(RAL8017)'|| $ind2 === 'Антрацит(7016RAL)' ? 'https://iem.plisse.ltd/tradeMasterImages/plisseltd/o2b.jpg': 'https://iem.plisse.ltd/tradeMasterImages/plisseltd/o2w.jpg'  } "   />

                </div>
            {/if}

            <div class="col-6">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">Москитное полотно</label>
                        <select class="form-control form-select" bind:value={ind3}>
                            {#each Object.entries(polotno) as [value, name]}
                                <option value="{value}">{name}</option>
                            {/each}
                            <option value="Нет" >Нет</option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="col-6">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">Цвет</label>
                        <select class="form-control form-select" bind:value={$ind2} on:change={() => {changeInd2(); change()}}>
                            {#each data.options.ind2 as item}
                                <option value="{item}">{item}</option>
                            {/each}
                        </select>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">

            <div class="col-12">
                <div class="form-group boxed">
                    <div class="alert alert-outline-danger">
                        К расчету принимаются только размеры светового проема!
                    </div>
                </div>
            </div>

            <div class="col-6">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">250 ≥ Шир., мм ≥ 1000</label>
                        <input type="number" class="form-control" step="10" min="250" max="1000" bind:value={$width} use:validate_int={$width} on:wheel={(e) => { if (document.activeElement === e.target) e.preventDefault(); }}>
                    </div>
                </div>
            </div>
            <div class="col-6">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">250 ≥ Выс., мм ≥ 3000</label>
                        <input type="number" class="form-control" step="10" min="250" max="3300" bind:value={$height} use:validate_int={$height} on:wheel={(e) => { if (document.activeElement === e.target) e.preventDefault(); }}>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-6">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">Количество</label>
                        <input type="number" class="form-control" min="1" bind:value={$count} use:validate_int={count}>
                    </div>
                </div>
            </div>
            <RalColor color={$ind2} bind:comment={$comment}/>
            <div class="col-6">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <div class="input-wrapper">
                            <label class="form-label">Примечание</label>
                            <textarea class="form-control" bind:value={$comment}></textarea>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
{/await}

<div id="toast-ind1" class="toast-box toast-top bg-danger">
    <div class="in">
        <div class="text">
            При высоте больше 1400 мм рекомендуется поставить перемычку
        </div>
    </div>
</div>
